import styled from "styled-components";
import {
  CarOutlined,
  ShoppingCartOutlined,
  CoffeeOutlined,
  BankOutlined,
  SendOutlined,
  GiftOutlined,
} from "@ant-design/icons";

export const icons = [
  CarOutlined,
  ShoppingCartOutlined,
  CoffeeOutlined,
  BankOutlined,
  SendOutlined,
  GiftOutlined,
];

export const places = [
  {
    id: 1,
    title: "Taxi Station",
    desc: `Taxi Station Lorem ipsum dolor amet, consectetur adipiscing elit.
           Integer ultrices malesuada`,
  },
  {
    id: 2,
    title: "Shopping Market",
    desc: `Taxi Station Lorem ipsum dolor amet, consectetur adipiscing elit.
           Integer ultrices malesuada`,
  },
  {
    id: 3,
    title: "Coffee Shop",
    desc: `Taxi Station Lorem ipsum dolor amet, consectetur adipiscing elit.
           Integer ultrices malesuada`,
  },
  {
    id: 4,
    title: "Bank",
    desc: `Taxi Station Lorem ipsum dolor amet, consectetur adipiscing elit.
           Integer ultrices malesuada`,
  },
  {
    id: 5,
    title: "Kid Toys Station",
    desc: `Taxi Station Lorem ipsum dolor amet, consectetur adipiscing elit.
           Integer ultrices malesuada`,
  },
  {
    id: 6,
    title: "Gift Store",
    desc: `Taxi Station Lorem ipsum dolor amet, consectetur adipiscing elit.
           Integer ultrices malesuada`,
  },
];

export const cardData = [
  {
    id: 1,
    imgUrl: "/images/accomodation.jpg",
    title: "GUEST ROOM SUITE ",
    subtitle: "Foxegan Hotel",
    desc: `Lorem ipsum dolor sit amet,
     consectetur adipiscing elit. Integer ultrices
      malesuada ante quis pharetra. Nullam non bibendum dolor.
     Ut vel turpis accumsan, efficitur dolor fermentum, tincidunt
      metus. Etiam ut ultrices nibh. Etiam aliquam mauris 
      non hendrerit faucibus. Proin`,
  },

  {
    id: 2,
    imgUrl: "/images/accomodation-1920.jpg",
    title: "Bus Station ",
    subtitle: "Bus to Foxegan",
    desc: `Lorem ipsum dolor sit amet,
     consectetur adipiscing elit. Integer ultrices
      malesuada ante quis pharetra. Nullam non bibendum dolor.
     Ut vel turpis accumsan, efficitur dolor fermentum, tincidunt
      metus. Etiam ut ultrices nibh. Etiam aliquam mauris 
      non hendrerit faucibus. Proin`,
  },
  {
    id: 3,
    imgUrl: "/images/accomodation-1.jpg",
    title: "HIGH SPEED TRAIN ",
    subtitle: "Train Station",
    desc: `Lorem ipsum dolor sit amet,
     consectetur adipiscing elit. Integer ultrices
      malesuada ante quis pharetra. Nullam non bibendum dolor.
     Ut vel turpis accumsan, efficitur dolor fermentum, tincidunt
      metus. Etiam ut ultrices nibh. Etiam aliquam mauris 
      non hendrerit faucibus. Proin`,
  },
];

export const brides = [
  {
    id: 1,
    imgUrl: "/images/bridesmaid-1.jpg",
    title: "- ROOM MATE -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 2,
    imgUrl: "/images/bridesmaid-2.jpg",
    title: "- FUTURE SISTER IN LAW -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 3,
    imgUrl: "/images/bridesmaid-3.jpg",
    title: "- SISTER -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 4,
    imgUrl: "/images/bridesmaid-4.jpg",
    title: "- COLLEGE FRIEND -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 5,
    imgUrl: "/images/bridesmaid-5.jpg",
    title: "- BEST FRIEND -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 6,
    imgUrl: "/images/bridesmaid-6.jpg",
    title: "- BEST - ROOM MATE - -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
];
export const groomsmen = [
  {
    id: 1,
    imgUrl: "/images/groomsmen-1.jpg",
    title: "- ROOM MATE -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 2,
    imgUrl: "/images/groomsmen-2.jpg",
    title: "- FUTURE BROTHER IN LAW -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 3,
    imgUrl: "/images/groomsmen-3.jpg",
    title: "-  BROTHER -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 4,
    imgUrl: "/images/groomsmen-4.jpg",
    title: "- COLLEGE FRIEND -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 5,
    imgUrl: "/images/groomsmen-5.jpg",
    title: "- BEST FRIEND -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
  {
    id: 6,
    imgUrl: "/images/groomsmen-6.jpg",
    title: "- BEST - ROOM MATE - -",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultrices malesuada ante",
  },
];

export const data = [
  {
    id: 1,
    imgUrl: "../../utils/images/slide-1.jpg",
  },
  {
    id: 2,
    imgUrl: "../../utils/images/slide-2.jpg",
  },
  {
    id: 3,
    imgUrl: "../../utils/images/slide-3.jpg",
  },
];

export const weddingInfo = [
  {
    id: 1,
    imageUrl: "/images/location-2.jpg",
    title: "LOCATION",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing 
      elit. Integer ultrices malesuada ante quis pharetra. Nullam non`,
    buttonTitle: "GET DIRECTION",
    buttonUrl: "/location",
  },
  {
    id: 2,
    imageUrl: "/images/accomodation-1.jpg",
    title: "ACCOMODATION",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing 
      elit. Integer ultrices malesuada ante quis pharetra. Nullam non`,
    buttonTitle: "ACCOMODATION",
    buttonUrl: "/accomodation",
  },
  {
    id: 3,
    imageUrl: "/images/gift-reg.jpg",
    title: "GIFT REGISTRY",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing 
      elit. Integer ultrices malesuada ante quis pharetra. Nullam non`,
    buttonTitle: "GIFT LIST",
    buttonUrl: "/gift-registry",
  },
];

export const footerImg = [
  {
    id: 1,
    image: "/images/footer-image-5.jpg",
    showRsvp: false,
  },
  {
    id: 2,
    image: "/images/slide-image.jpg",
    showHome: true,
  },
  {
    id: 3,
    imgUrl: "/images/slide-footer.jpg",
    showHer: true,
  },
  {
    id: 4,
    imgUrl: "/images/footer-rsvp.jpg",
    showHim: true,
  },
];
export const galleryImg = [
  {
    id: 1,
    imgUrl: "/images/gallery-1.jpg",
  },
  {
    id: 2,
    imgUrl: "/images/gallery-2.jpg",
  },
  {
    id: 3,
    imgUrl: "/images/gallery-3.jpg",
  },
  {
    id: 4,
    imgUrl: "/images/gallery-4.jpg",
  },
  {
    id: 5,
    imgUrl: "/images/gallery-5.jpg",
  },
  {
    id: 6,
    imgUrl: "/images/gallery-6.jpg",
  },
  {
    id: 7,
    imgUrl: "/images/gallery-7.jpg",
  },
  {
    id: 8,
    imgUrl: "/images/gallery-8.jpg",
  },
  {
    id: 9,
    imgUrl: "/images/gallery-9.jpg",
  },
];

export const HeartStyle = styled.div`
  .heart-divider {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
  }
  .white-line {
    width: 30px;
    height: 8px;
    display: inline-block;
    padding: 3px;
    margin: 0 3.5px;
    border-top: solid 1px #fff;
  }
`;
export const DoubleLineStyle = styled.div`
  .banner-text.light {
    color: #fff;
    border-top: medium double #fff;
    border-bottom: medium double #fff;
  }
  .banner-text.medium {
    padding: 7px 50px;
    font-size: 16px;
    font-family: "Oswald", sans-serif;
    margin: 10px 0;
    letter-spacing: 3px;
    transition: all 0.4s ease-in;
    @media (max-width: 767px) {
      padding: 5px 30px;
      font-size: 130%;
      margin: 0 0 25px 0;
      text-align: center;
    }
  }
`;
